<app-navbar [navClass]="'defaultscroll is-sticky'" [navLight]="false"></app-navbar>

<section class="relative lg:pb-24 pb-16 md:mt-[84px] mt-[70px]">
  <div class="md:container container-fluid relative">
    <div class="relative overflow-hidden md:rounded-md shadow dark:shadow-gray-800 h-52 bg-[url('../../assets/images/bg/cta.jpg')] bg-center bg-no-repeat bg-cover"></div>
  </div>

  <div class="container relative md:mt-24 mt-16">
    <div class="md:flex">
      <!-- Sidebar Tabs -->
      <div class="lg:w-1/4 md:w-1/3 md:px-3">
        <app-tab-management></app-tab-management>
      </div>

      <!-- Main Content -->
      <div class="lg:w-3/4 md:w-2/3 md:px-3 mt-6 md:mt-0">
        <div>
          <h5 class="text-lg font-semibold mb-6">Short-Term Rental Management</h5>

          <p class="text-slate-400 mt-4">
            HarmoNest provides a complete management system for short-term rental owners. From calendar syncing and dynamic pricing to guest communication and booking analytics — everything you need is in one place.
          </p>
          <p class="text-slate-400 mt-2">
            Whether you're managing one apartment or a portfolio of properties across cities, our platform makes it easy to stay organized, increase occupancy, and deliver an exceptional guest experience.
          </p>
        </div>

        <div class="mt-10">
          <h5 class="text-lg font-semibold mb-6">Your Listings</h5>

          <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
            <div *ngFor="let item of package | slice:0:6" class="group rounded-md shadow dark:shadow-gray-700">
              <app-grid-data [packageData]="item"></app-grid-data>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
<app-switcher></app-switcher>
